import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type ISaveButtonProps = IBasicButtonProps;

const DefaultProps: Partial<ISaveButtonProps> = {};

/** @registry BasicButton preset with default label "Save"; no styling overrides beyond the base button. */
export const SaveButton = React.forwardRef<HTMLButtonElement, ISaveButtonProps>(
  ({ children = 'Save', ...props }, ref) => {
    return (
      <BasicButton {...DefaultProps} {...props} ref={ref}>
        {children}
      </BasicButton>
    );
  },
);
SaveButton.displayName = 'SaveButton';
